import { SwiperOptions } from 'swiper/types';

export const swiperOptions: SwiperOptions = {
  slidesPerView: 'auto',
  pagination: false,
  navigation: false,
  freeMode: true,
  speed: 600,
  slidesOffsetBefore: 10,
  slidesOffsetAfter: 14
};

export const swiperOptionsList: SwiperOptions = {
  slidesPerView: 4,
  pagination: false,
  navigation: false,
  freeMode: true,
  speed: 600,
  slidesOffsetBefore: 10,
  slidesOffsetAfter: 14,
  direction: 'vertical',
};
